import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import classNames from 'classnames';

import { Box, Text, CenteredContainer } from '@nerdwallet/currency';
import WpEmbed from '@nerdwallet/react-wp-embed';
import classes from '@nerdwallet/base-styles/classes';
import appConfig from '@nerdwallet/app-config';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import { isInBuilder } from '../../lib/helpers';
import './calculator.less';

import { boolCheckboxSpec, stringInputSpec } from '../../lib/editing-configs';

const Calculator = ({ cffId, history, fullWidthMobile }) => {
  const iframeUrl = `${appConfig.SITE_BASE_URL}/blog/cff/?form_id=${cffId}`;

  const defaultEditorOutput = () => {
    const url = get(history, 'location.pathname');

    if (isInBuilder(url)) {
      return (
        <CenteredContainer
          className={classNames([
            'calculator__default-output',
            'landing-page-standard__max-widths',
          ])}
        >
          <Box
            className={classNames([
              classes('padding-vertical-5'),
              classes('text-align-center'),
            ])}
          >
            <Text size="large" bold align="center">
              Enter a CFF ID to make a calculator appear
            </Text>
          </Box>
        </CenteredContainer>
      );
    }
    return null;
  };

  return !cffId ? (
    defaultEditorOutput()
  ) : (
    <CenteredContainer
      className={classNames([
        'calculator-container',
        classes('padding-vertical-3'),
        {
          fullWidth: !fullWidthMobile,
        },
      ])}
    >
      <WpEmbed src={iframeUrl} />
    </CenteredContainer>
  );
};

Calculator.defaultProps = {
  fullWidthMobile: false,
};

Calculator.propTypes = {
  cffId: PropTypes.string,
  fullWidthMobile: PropTypes.bool,
  history: PropTypes.object,
};

Calculator.getEditingConfig = () => [
  stringInputSpec('cffId', 'Calculated Fields Form ID', {
    help: 'For a list of CFFs you can display on landing pages, login to Wordpress and navigate to Settings > Calculated Fields Form.',
  }),
  boolCheckboxSpec('fullWidthMobile', '100% width in mobile viewports?', {
    help: 'The Paragraph defaults to a width of 280px on mobile viewports. Check this box to make it 100% width for mobile viewports instead.',
  }),
];

export default compose(withRouter, connect())(Calculator);
